import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const SherpaTravelRestrictionShow = (props) => (
        <ShowGuesser {...props} resource="sherpa-travel-restrictions"/>
);

export default SherpaTravelRestrictionShow;
